import React from 'react'

const MobileBanner = () => {
	return (
		<div>
			<div class='container-fluid px-1 px-md-1'>
				<div
					class='page-header min-height-100 border-radius-xl mt-0'
					style={{
						backgroundImage: "url('../../assets/img/ivancik.jpg')",
					}}
				>
					<span class='mask opacity-4'></span>
				</div>
			</div>
		</div>
	)
}

export default MobileBanner
